import { cva } from 'class-variance-authority';

export const cvaCarNumberExample = cva(
  ['CarNumberExampleStyles-cvaCarNumberExample', 'w-fit', 'rounded-[0.8rem]'],
  {
    variants: {
      theme: {
        dark: ['bg-[#252331]'],
        darker: ['bg-[#070417]'],
      },
    },
  }
);

export const cvaCarNumberExampleInner = cva([
  'CarNumberExampleStyles-cvaCarNumberExample',
  'flex gap-0.8',
  'py-1.4 px-1.6',
  'text-l-b text-cWhite',
]);
